import { ReactElement } from 'react';
import { ProcessIconT } from '@/store/slices/progressSlice';
import IcoInfo from '@/assets/svg/ico_info.svg?react';

export const getIcon = (iconType?: ProcessIconT): ReactElement | null => {
    switch (iconType) {
        case 'failed': {
            return <IcoInfo />;
        }
        default: {
            return null;
        }
    }
};
